var render = function render(_c,_vm){return _c('div',{staticClass:"row q-mt-md"},[(_vm.$slots.default)?_c('div',{staticClass:"col-xs-12",class:{ 'col-md-6': _vm.$slots.col2, 'q-mb-md': _vm.parent.$q.screen.lt.md }},[_vm._t("default")],2):_vm._e(),(_vm.$slots.col2)?_c('div',{staticClass:"col-xs-12",class:{ 'col-md-6': _vm.$slots.default, 'text-right': _vm.parent.$q.screen.gt.sm }},[_vm._t("col2")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }